import { render, staticRenderFns } from "./UsersSidebar.vue?vue&type=template&id=c6828ada&"
import script from "./UsersSidebar.vue?vue&type=script&lang=js&"
export * from "./UsersSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports